import i18n from "./i18n";

function changeLocale () {
    if( i18n.language=="en")
         i18n.changeLanguage("ar");
         else
         i18n.changeLanguage("en");
       
   }
   export  default changeLocale